import { createAsyncThunk } from "@reduxjs/toolkit";
import { addBiddingApi } from "./api";

export const addBidding = createAsyncThunk(
  "bidding/addBidding",
  async (payload) => {
    try {
      const res = await addBiddingApi(payload);
      return res.data;
    } catch (error) {
      throw error.response.data.message;
    }
  }
);
